import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { BannerComponentProps } from '@/config/bannerRegistry';

export const BlackFridayBanner: React.FC<BannerComponentProps> = ({
  maxDiscount,
  redirectPath,
  onClose,
}) => {
  const { t } = useTranslation('common');
  const isPricingPage =
    typeof window !== 'undefined' &&
    window.location.pathname.includes('/pricing');

  return (
    <div className="relative z-10 flex gap-2 max-h-32 w-full items-center justify-center bg-[#040404] py-4 md:py-2">
      <img
        src="https://cdn.slidesai.io/Black%20Friday%20Sale%20Banner%20v1%20-%201440px.png"
        alt="black-friday-banner"
        className="absolute inset-0 hidden h-full w-full object-fill xl:block"
      />
      <div className="relative flex items-center justify-between gap-2 text-sm md:gap-0 md:space-x-4 md:text-base">
        <div className="text-white">
          <span className="mr-1">
            {t('blackFridaySale', 'Black Friday Sale:')}
          </span>
          <span className="font-semibold">
            {t('getUpToPercentOff', 'Get up to {{maxDiscount}}% off', {
              maxDiscount,
            })}
          </span>{' '}
          <span className="hidden md:inline">
            {t(
              'limitedTimeOffer',
              'on your subscription for a limited time only'
            )}
          </span>
        </div>
        {!isPricingPage && (
          <Link
            to={redirectPath}
            className="rounded-lg border-[#B2CCFF] text-sm font-semibold text-white underline md:bg-white md:px-4 md:py-2 md:text-[#C2180B] md:no-underline"
          >
            {t('claimOffer', 'Claim Offer')}
          </Link>
        )}
      </div>

      {/* Close button */}
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          className="block md:absolute size-8 right-4 top-3 rounded-full bg-transparent md:bg-white/90 text-white md:text-black p-1 transition-colors cursor-pointer hover:bg-white hover:text-black focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-black"
          aria-label={t('closeBanner', 'Close banner')}
        >
          <i className="ti ti-x size-6" />
        </button>
      )}
    </div>
  );
};
